import { useBoolean } from '@uifabric/react-hooks';
import { aPreferredLanguage } from 'features/LinkAttachmentModalBox/atom';
import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { idpService } from 'services/api/identity-provider.service';
import { useInvitationLanguage } from 'shared-state/invitationLanguage/hooks';

export interface IPersonalPreferencesState {
    switchLanguage: (newLang: string) => void;
    toggleHideDialog: () => void;
    hideDialog: boolean;
    language: string;
    setLanguage: React.Dispatch<React.SetStateAction<string>>;
    showLanguage: () => 'Deutsch' | 'English';
    openDialogBox: (lang: string) => void;
}

export const usePersonalPreferencesState: () => IPersonalPreferencesState = () => {
    const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
    const [language, setLanguage] = useState<string>('');
    const [preferredLanguage, setPreferredLanguage] = useRecoilState(aPreferredLanguage);

    const [, setInvitationLanguageChoice] = useInvitationLanguage();

    useEffect(() => {
        const getUserData = async () => {
            try {
                const response = await idpService.getUser();
                setPreferredLanguage(response.preferred_language);
                setInvitationLanguageChoice(response.preferred_language);
            } catch (error) {
                console.log(error);
            }
        };

        getUserData();
    }, []);

    const switchLanguage = async (newLang: string) => {
        await idpService.updateUser(undefined, undefined, undefined, newLang, undefined);

        window.location.reload();
    };

    const showLanguage = () => {
        const lang = preferredLanguage;
        if (lang === 'de') {
            return 'Deutsch';
        } else return 'English';
    };

    const openDialogBox = (lang: string) => {
        const lang2 = preferredLanguage;
        if (lang === lang2) {
            null;
        } else toggleHideDialog();
    };

    return {
        switchLanguage,
        hideDialog,
        toggleHideDialog,
        language,
        setLanguage,
        showLanguage,
        openDialogBox
    };
};
